// @flow
import schema from "src/schemas/locationSchema";
import { relationshipReducer } from "src/utils/reducerUtils";

export const locationRelationships = relationshipReducer({
  name: "locations",
  relationshipSchemas: schema.relationshipSchemas
});
